var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCameraTimes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(1.083 2.532)" },
                    React.createElement("path", { d: "M9.6,3.8L8.3,5.4H6.8" })),
                React.createElement("path", { d: "M26.7,26.3" }),
                React.createElement("path", { d: "M21.2,24.2H5c-1.2,0-2.2-1-2.2-2.2V10.1c0-1.2,1-2.2,2.2-2.2h3.2 M18.3,18c-1.4,2-4,2.5-6,1.1\n\t\ts-2.5-4-1.1-6c0.3-0.4,0.7-0.8,1.1-1.1" }),
                React.createElement("path", { d: "M19.9,24.2h3.7c1.2,0,2.2-1,2.2-2.2v-3.7" }),
                React.createElement("path", { d: "M27.1,3.7l-8.6,8.6" }),
                React.createElement("path", { d: "M18.5,3.7l8.6,8.6" })))));
});
export default IconCameraTimes;
//# sourceMappingURL=IconCameraTimes.js.map